export const PRODUCT_ADDONS_DATA_QUERY_KEY = 'product-addons-data';
